import { GOOGLE_TAG_CONSTANTS } from 'constants/googleTagConstants'

function onPageLoad(props) {
    props.handleGTagLogs(
        GOOGLE_TAG_CONSTANTS.PRE_LOAD_SCREEN_WEB,
        'When pre load screens comes up before loading of the test',
        {
            success: true,
            user_test_id: props.testStatus?.testStatus?.data?.userTestId,
        },
    )
}

function landingScreen(props, questions) {
    props.handleGTagLogs(
        GOOGLE_TAG_CONSTANTS.LANDING_SCREEN_TEST_WEB,
        'User lands on the 1st question of the test',
        {
            success: true,
            question_id: questions[0].questionList[0].question?.questionid,
            question_type: questions[0].questionList[0]?.question?.questionType,
            user_test_id: props?.testStatus?.testStatus?.data?.userTestId,
            external_id: questions[0].questionList[0]?.question?.questionExternalId,
        },
    )
}

function onSectionClick(props, _index) {
    const currentQuestion = props.testData.questionset[_index].questionList[0]
    props.handleGTagLogs(
        GOOGLE_TAG_CONSTANTS.TAP_SECTION_WEB,
        'User taps on any section in the test',
        {
            success: true,
            disconnection_time: props.queryparam.disconnect_time * 60,
            question_id: currentQuestion.question?.questionid,
            question_type: currentQuestion.question?.questionType,
            external_id: currentQuestion.question?.questionExternalId,
            user_test_id: props?.testStatus?.testStatus?.data?.userTestId,
            // what is option selected?, this event trigger when user swtiches from one subject to other
            options_selected: currentQuestion.question?.answerbyUser,
            section_name:
                props.testData.questionset[_index]?.subject[props.current_language],
        },
    )
}

export { onPageLoad, onSectionClick, landingScreen }
